import { CollaborationPostStatus, User } from "../../../features/user/types";
import { isUpsellRequiredForApproval } from "../../../utils/user";

export function resolveDefaultAprovalStatus(
  user: User,
  userCollabSettings: CollaborationPostStatus[]
) {
  const upsell = isUpsellRequiredForApproval(user);

  const defaultSetting = upsell
    ? userCollabSettings.find((setting) => {
        return setting.label === "Approved";
      }) ||
      userCollabSettings.find((setting) => {
        return setting.isPublishingAllowed;
      })
    : userCollabSettings.find((setting) => {
        return setting.isDefault;
      });
  return { defaultSetting, upsell };
}
